import type { Webviewer } from "lib";
import { useEffect } from "react";

import { runCommand } from "./commands";
import { HostEventSubscriptions } from "./eventSubscriptions";

/**
 * Serves the commands arriving on the Webviewer's `postMessage` channel while the viewer is mounted.
 *
 * The channel itself is opened by the Webviewer on construction, early enough to catch the Custom
 * Tabs handshake; this only supplies what runs the commands once the viewer is in a state to serve
 * them. Whatever events the host subscribed to over the channel are held here too, so they last
 * exactly as long as the viewer that emits them.
 */
export function useServeCommandChannel(webviewer: Webviewer) {
    useEffect(() => {
        const events = new HostEventSubscriptions(webviewer);
        webviewer.commandChannel.setRunner((message) => runCommand(webviewer, message, events));

        return () => {
            webviewer.commandChannel.clearRunner();
            events.dispose();
        };
    }, [webviewer]);
}
